import { InstructionalVideoDto, WatchState } from "../model/InstructionalVideoDtos"
import { PagedList } from "../../../core/api/pagedList"
import InstructionalVideosApi from "../api/instructionalVideosApi"
import { t } from "i18next"
import { useNavigate } from "react-router-dom"
import { Column, HeaderFilter, Sorting } from "devextreme-react/data-grid"
import { useWatchStates } from "../hook/useWatchStates"
import { ColumnActions, GenericDataGrid, IconButtonVideo, Row } from "../../../core/components"

export const InstructionalVideosList: React.FC = () => {
    const navigate = useNavigate()
    const { watchStates, watchStatesLookup } = useWatchStates()

    const fetchData = async (odataQueryParameters?: string): Promise<PagedList<InstructionalVideoDto>> => {
        const response = await InstructionalVideosApi.getVideos(odataQueryParameters)
        return response
    }

    const goToVideo = (id: string) => {
        navigate(`/instructional-videos/${id}`)
    }

    return (
        <GenericDataGrid
            id="InstructionalVideoList"
            className="card m-05 border-light instructional-videos-list-height"
            rowKey={"idInstructionalVideo"}
            fetchData={fetchData}
            handleEdit={goToVideo}>
            <HeaderFilter visible />
            <Sorting mode="single"></Sorting>
            <Column
                dataField="title"
                caption={t("Video")}
                allowHeaderFiltering={false} />
            <Column
                dataField="description"
                caption={t("Description")}
                width={300}
                allowSorting={false}
                allowHeaderFiltering={false} />
            <Column
                dataField="watchState"
                caption={t("State")}
                dataType="string"
                minWidth={100}

                fixed
                fixedPosition="right"
                lookup={watchStatesLookup}
                allowHeaderFiltering>
                <HeaderFilter search={{ enabled: true }} allowSelectAll dataSource={watchStates} />
            </Column>
            <ColumnActions>
                {(cellInfo) => (
                    <IconButtonVideo size="small" onClick={() => goToVideo(cellInfo.data.idInstructionalVideo)} />
                )}
            </ColumnActions>
        </GenericDataGrid>
    )
}
